import { useState } from "react";
import { IMaskInput } from "react-imask";
import { formatISBN } from "./formatISBN";

export interface ISBNMaskProps {
  onChange: (event: { target: { value: string } }) => void;
  value: string;
  [key: string]: unknown;
}

export const ISBNMask = ({ onChange, value, ...other }: ISBNMaskProps) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <IMaskInput
      {...other}
      mask="000 - 00 - 00 - 00000 - 0"
      definitions={{
        "0": /[0-9]/,
      }}
      lazy={!isFocused}
      placeholderChar="_"
      value={formatISBN(value)}
      onAccept={(maskedValue: string) => {
        // Extract only digits, removing dashes, spaces, and underscores
        const unmaskedValue = maskedValue.replace(/[\s\-_]/g, "");
        onChange({ target: { value: unmaskedValue } });
      }}
      onFocus={(e: React.FocusEvent) => {
        setIsFocused(true);
        if (other.onFocus) {
          (other.onFocus as (e: React.FocusEvent) => void)(e);
        }
      }}
      onBlur={(e: React.FocusEvent) => {
        setIsFocused(false);
        if (other.onBlur) {
          (other.onBlur as (e: React.FocusEvent) => void)(e);
        }
      }}
      overwrite
    />
  );
};
